import { actions, assign } from 'xstate';
const { choose } = actions;

import {
  INITIAL_ABSOLUTE_DATE_FILTERS,
  INITIAL_FILTERS,
  INITIAL_RELATIVE_DATE_FILTERS,
  INITIAL_SECTIONS,
} from './constants';
import { Context, FilterType } from './types';
import { areFiltersEmpty, isFilterEmpty, areSomeFiltersActive } from './utils';

export const setFilterSections = choose([
  {
    cond: (ctx: Context) => !!ctx.activeFilters,
    actions: assign((ctx: Context) => ({
      sections: Object.keys(ctx.sections).reduce(
        (acc, sectionName: FilterType) => {
          return {
            ...acc,
            [sectionName]: !isFilterEmpty(
              sectionName,
              ctx.activeFilters[sectionName]
            ),
          };
        },
        {} as Record<FilterType, boolean>
      ),
    })),
  },
  {
    cond: (ctx: Context) => ctx.activeFilters === null,
    actions: assign(() => ({
      sections: INITIAL_SECTIONS,
    })),
  },
]);

export const setFilterOrClear = choose([
  {
    cond: (ctx: Context) =>
      ctx.activeFilters === null && areFiltersEmpty(ctx.inlineFilters),
    actions: [],
  },
  {
    cond: (ctx: Context) => areSomeFiltersActive(ctx.inlineFilters),
    actions: [
      assign((ctx: Context) => ({
        activeFilters: ctx.inlineFilters,
      })),
      'applyFilters',
    ],
  },
  {
    cond: (ctx: Context) =>
      areFiltersEmpty(ctx.inlineFilters) && ctx.activeFilters !== null,
    actions: [
      assign(() => ({
        activeFilters: null,
        inlineFilters: INITIAL_FILTERS,
      })),
      'clearFilters',
    ],
  },
]);

export const setFilterClear = choose([
  {
    cond: (ctx: Context) =>
      areFiltersEmpty(ctx.inlineFilters) && ctx.activeFilters === null,
    actions: [],
  },
  {
    cond: (ctx: Context) => ctx.activeFilters !== null,
    actions: [
      assign(() => ({
        activeFilters: null,
        inlineFilters: INITIAL_FILTERS,
        sections: INITIAL_SECTIONS,
      })),
      'clearFilters',
    ],
  },
]);

export const setDateTabEmpty = choose([
  {
    cond: (ctx: Context) => ctx.inlineFilters.date.type === 'relative',
    actions: assign((ctx: Context) => ({
      inlineFilters: {
        ...ctx.inlineFilters,
        date: {
          ...ctx.inlineFilters.date,
          ...INITIAL_RELATIVE_DATE_FILTERS,
        },
      },
    })),
  },
  {
    cond: (ctx: Context) => ctx.inlineFilters.date.type === 'timeRange',
    actions: assign((ctx: Context) => ({
      inlineFilters: {
        ...ctx.inlineFilters,
        date: {
          ...INITIAL_ABSOLUTE_DATE_FILTERS,
          ...ctx.inlineFilters.date,
        },
      },
    })),
  },
]);
